import React from 'react'
import { connect } from 'react-redux'
import FormInput from './FormInput'
import FormDropdown from './FormDropdown'
import Bar from './Bar'
import {
    ajaxFeedbackFilterV2,
    convertTimeframeTitle,
    deleteRatingsFilter,
    getLocation,
    setCurrentPage,
    setCustomTimeframe,
    setFilterTimeframe,
    setLocation,
    setQuery,
    setRatingsFilter,
    setSorting,
    updateModalContent,
    validateFeedbackSorting
} from '../redux/FeedbackRedux'
import TimeframeRangeLabel from '../TimeframeRangeLabel'
import { timeframeRangeText } from '../helpers/timeframeRange'

/**
 * RTF-4901: open the native calendar when the user clicks the Custom Time Frame
 * date fields. A transparent overlay (`.custom-date-overlay`) sits on top of each
 * <input type="date"> so showPicker() is the SINGLE trigger in every browser —
 * including Firefox, whose native calendar button cannot be hidden via CSS and
 * otherwise double-toggled against this handler (open, then immediately close, so
 * the icon appeared to do nothing). Rendered only when showPicker() is supported;
 * otherwise the native calendar button is left untouched as a fallback.
 */
const supportsShowPicker = typeof HTMLInputElement !== 'undefined'
    && typeof HTMLInputElement.prototype.showPicker === 'function';

function openDatePicker(input) {
    if (!input) {
        return;
    }

    try {
        input.showPicker();
    } catch (error) {
        // No-op: fall back to the browser's native date-field interaction.
    }
}

class SearchBar extends React.Component {
    constructor(props) {
        super(props);

        this.startDateRef = React.createRef();
        this.endDateRef = React.createRef();

        if (props.state.timeframe === null) {
            let timeframe = window.localStorage.getItem("timeframe");
            timeframe = timeframe === null ? "last30" : timeframe;
            if (props.state.custom_qr_code !== null)
                timeframe = "lifetime"
            props.dispatch(setFilterTimeframe(timeframe));
        }

        let sorting = window.localStorage.getItem("sorting");
        props.dispatch(setSorting(validateFeedbackSorting(sorting)));

        let location = getLocation();

        if (window.filterRating !== null && window.filterRating !== undefined) {
            setRatingsFilter(window.filterRating);
        } else if (props.state.status === window.feedbackStatus.RatingsOnly.value && location && location.current !== 'FeedbackDetailBar') {
            props.state.business.five_star_minimum ? setRatingsFilter([4, 3, 2, 1]) : setRatingsFilter([3, 2, 1]);
        }else if (location && location.current !== 'FeedbackDetailBar') {
            deleteRatingsFilter();
        }

        props.dispatch(ajaxFeedbackFilterV2(true, true))

        this.state = {
            displayClear: props.state.query !== "",
            status: props.state.status === "null" || props.state.status === null ? "All" : props.state.status,
            // RTF-3722: date-range-aware per-status counts (+ lifetime totals for the
            // "count/lifetime" display on Open & Pending) published by the sidebar
            // (fetchSidebarCounts) so the mobile status dropdown can display them.
            feedbackCounts: window.sidebarFeedbackCounts ?? null,
            feedbackLifetimeCounts: window.sidebarFeedbackLifetimeCounts ?? null,
        }

        this.handleSidebarCounts = this.handleSidebarCounts.bind(this);

        setLocation('SearchBar');
    }

    componentDidMount() {
        window.addEventListener('sidebar-feedback-counts-updated', this.handleSidebarCounts);
    }

    componentWillUnmount() {
        window.removeEventListener('sidebar-feedback-counts-updated', this.handleSidebarCounts);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    handleSidebarCounts(event) {
        const detail = event.detail || {};
        this.setState({
            feedbackCounts: detail.counts ?? null,
            feedbackLifetimeCounts: detail.lifetime ?? null,
        });
    }

    /**
     * RTF-3722: format the count shown for a status in the mobile dropdown.
     * Open & Pending mirror the desktop sidebar's "count/lifetime" (e.g. "0/90");
     * every other status shows just the date-range count. Returns null (no count
     * rendered) until the sidebar has published its counts.
     */
    formatStatusCount(statusValue) {
        const counts = this.state.feedbackCounts;
        const countKey = {
            [window.feedbackStatus.Open.value]: 'countOpen',
            [window.feedbackStatus.Pending.value]: 'countPending',
            [window.feedbackStatus.Resolved.value]: 'countResolved',
            All: 'countAll',
            [window.feedbackStatus.RatingsOnly.value]: 'countRatingsOnly',
        }[statusValue];

        if (!counts || !countKey || counts[countKey] == null) {
            return null;
        }

        let display = counts[countKey];

        const lifetime = this.state.feedbackLifetimeCounts;
        const lifetimeKey = {
            [window.feedbackStatus.Open.value]: 'countOpen',
            [window.feedbackStatus.Pending.value]: 'countPending',
        }[statusValue];

        if (lifetimeKey && lifetime && lifetime[lifetimeKey] != null) {
            display = display + '/' + lifetime[lifetimeKey];
        }

        return display;
    }

    dispatchSearch() {
        let query = $("input.feedback-search").val();
        window.localStorage.setItem("feedback_search", query);
        this.props.dispatch(setQuery(query));
        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    dispatchTimeframe() {
        const $el = $(event.target).closest('.dropdown-item');
        let timeframe = $el.attr("id");
        const timeframeLabel = convertTimeframeTitle(timeframe);

        window.localStorage.setItem("timeframe", timeframe);
        window.localStorage.setItem("timeframeLabel", timeframeLabel);

        if (timeframe !== "custom") {
            window.localStorage.removeItem("prev_date");
            window.localStorage.removeItem("next_date");
        }

        this.props.dispatch(setFilterTimeframe(timeframe));
        this.props.dispatch(ajaxFeedbackFilterV2(true, true));

        if (window.refreshSidebarCounts) {
            window.refreshSidebarCounts();
        }

        const input = document.querySelector('.timelineFeedbackHiddenInput');
        input.value = timeframeLabel
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    dispatchDiplayStatus() {
        let status = $(event.target).attr("id");
        if (this.state.status == status) return;
        if (this.state.status == "All") {
            window.location.href = window.location.href + `?status=${status}`;
        } else {
            window.location.href = window.location.href.replace(`?status=${this.state.status}`, status == "All" ? "" : `?status=${status}`);
        }
        this.setState({ ...this.state, status });
    }

    handleExportClick(event) {
        const modal_id = "download_XLS";
        const modal_title = __('Download XLS Export');
        const modal_body = "exportXls";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "export_xls_send_btn";
        const button_2_text = __("Send Report");
        this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
        jQuery('.modal:not(.error)').modal();
    }

    doChangeTimeFrame() {
        var prev = jQuery("#start_date").val();
        var next = jQuery("#end_date").val();

        if (prev > next) {
            document.getElementById("start_date").blur();
            document.getElementById("end_date").blur();
            this.props.dispatch(updateModalContent({ modal_id: "date_late_error", modal_title: __('End Date must be later than the Start Date.'), modal_body: '', button_1_class: 'primary', button_1_id: 'cancel', button_1_text: __('Ok') }));
            jQuery('.modal:not(.error)').modal();
            return;
        }

        window.localStorage.setItem("prev_date", prev);
        window.localStorage.setItem("next_date", next);

        this.props.dispatch(setCustomTimeframe({ next, prev }));
        this.props.dispatch(setCurrentPage(1));
        this.props.dispatch(ajaxFeedbackFilterV2(true, true))

        // RTF-4900: the preset path (dispatchTimeframe) refreshes the sidebar
        // badge counts; the custom-range path must do the same so "X out of Y"
        // reflects the selected date range. prev_date/next_date were just written
        // to localStorage above, so fetchSidebarCounts() picks up the custom range.
        if (window.refreshSidebarCounts) {
            window.refreshSidebarCounts();
        }
    }

    getStatusDropdownItems() {
        // RTF-3722: attach the sidebar-provided count to each status so the mobile
        // dropdown mirrors the sidebar badges (Open/Pending show "count/lifetime").
        // `count` is rendered right-aligned and mobile-only by FormDropdown; null
        // until the counts have been fetched.
        let dropdownItems = [
            { text: window.feedbackStatus.Open.label, id: window.feedbackStatus.Open.value, link: '?status=' + window.feedbackStatus.Open.value, count: this.formatStatusCount(window.feedbackStatus.Open.value) },
            { text: window.feedbackStatus.Pending.label, id: window.feedbackStatus.Pending.value, link: '?status=' + window.feedbackStatus.Pending.value, count: this.formatStatusCount(window.feedbackStatus.Pending.value) },
            { text: window.feedbackStatus.Resolved.label, id: window.feedbackStatus.Resolved.value, link: '?status=' + window.feedbackStatus.Resolved.value, count: this.formatStatusCount(window.feedbackStatus.Resolved.value) },
            { text: __('All'), id: 'All', link: '?status=All', count: this.formatStatusCount('All') }
        ];

        if (this.props.state.businessHasAutoPilot) {
            dropdownItems.push({ text: window.feedbackStatus.RatingsOnly.label, id: window.feedbackStatus.RatingsOnly.value, count: this.formatStatusCount(window.feedbackStatus.RatingsOnly.value) });
        }

        return dropdownItems;
    }
    render() {
        return (
            <Bar>
                <div className={'search-bar-wrapper d-flex w-100'}>
                    <div className={'d-flex search-bar-wrapper w-100'}>
                        <div className="d-flex search-bar-wrapper align-items-xl-center">
                            <FormDropdown
                                title={convertTimeframeTitle(this.props.state.timeframe)}
                                items={
                                    [
                                        { text: __('Today'), id: "today" },
                                        { text: __('Yesterday'), id: "yesterday" },
                                        { text: __('Week to Date'), id: "weekToDate" },
                                        { text: __('Month to Date'), id: "monthToDate" },
                                        { text: __('Last 30 Days'), id: "last30" },
                                        { text: __('Lifetime'), id: "lifetime" },
                                        { text: __('Custom'), id: "custom" }
                                    ].map(item => ({
                                        ...item,
                                        range: timeframeRangeText(
                                            item.id,
                                            this.props.state.business?.call_at_timezone,
                                            this.props.state.business?.created_at
                                        )
                                    }))
                                }
                                classes={"mr-2 roboto"}
                                buttonClasses={"roboto"}
                                itemOnClickFunction={this.dispatchTimeframe.bind(this)}
                            />
                            <div className="d-flex align-items-center mr-1">
                                <TimeframeRangeLabel
                                    timeframe={this.props.state.timeframe}
                                    timezone={this.props.state.business?.call_at_timezone}
                                    lifetimeStart={this.props.state.business?.created_at}
                                />
                            </div>
                            <div className="align-items-center mr-1" style={{ display: this.props.state.timeframe === "custom" ? "flex" : "none" }}>
                                <div className="custom-date-wrap mr-2">
                                    <input
                                        ref={this.startDateRef}
                                        className="form-control custom-date"
                                        // 18px right padding = ~12px calendar-picker-indicator inset + 6px gap from the date text
                                        style={{ padding: "0 18px 0 0", cursor: "pointer" }}
                                        value={this.props.state.timeframe_prev}
                                        onChange={() => { this.doChangeTimeFrame() }}
                                        type="date"
                                        min='1899-01-01'
                                        max={this.props.state.max_Date}
                                        id="start_date"
                                        required
                                    />
                                    {supportsShowPicker && (
                                        <span
                                            className="custom-date-overlay"
                                            onClick={() => openDatePicker(this.startDateRef.current)}
                                        />
                                    )}
                                </div>
                                <div className="mx-1">{__('To')}</div>
                                <div className="custom-date-wrap mr-2">
                                    <input
                                        ref={this.endDateRef}
                                        // 18px right padding = ~12px calendar-picker-indicator inset + 6px gap from the date text
                                        style={{ padding: "0 18px 0 0", cursor: "pointer" }}
                                        className="form-control custom-date"
                                        value={this.props.state.timeframe_next}
                                        onChange={() => { this.doChangeTimeFrame() }}
                                        type="date"
                                        min='1899-01-01'
                                        max={this.props.state.max_Date}
                                        id="end_date"
                                        required
                                    />
                                    {supportsShowPicker && (
                                        <span
                                            className="custom-date-overlay"
                                            onClick={() => openDatePicker(this.endDateRef.current)}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex w-100">
                            <form className="w-100 position-relative d-flex align-items-center " onSubmit={(e) => {
                                e.preventDefault();
                                this.dispatchSearch();
                            }}>
                                <FormInput
                                    placeholder={__('Search Feedbacks...')}
                                    classes={"w-100 roboto feedback-search"}
                                    onChange={
                                        () => {
                                            if ($("input.feedback-search").val() !== "") {
                                                this.setState({ ...this.state, displayClear: true })
                                            } else {
                                                this.setState({ ...this.state, displayClear: false })
                                            }
                                        }
                                    }
                                    defaultValue={this.props.state.query}
                                />
                                {this.state.displayClear && <span className='position-absolute cursor-pointer' onClick={() => {
                                    $("input.feedback-search").val("");
                                    this.dispatchSearch();
                                    this.setState({ ...this.state, displayClear: false })
                                }} style={{ right: '35px' }}>x</span>}
                            </form>
                            <span onClick={this.dispatchSearch.bind(this)}
                                className="btn btn-primary searchbar-button position-relative">{__('Search')}</span>
                        </div>
                    </div>

                    <div className={'d-flex searchbar-dropdowns-wrapper'}>
                        <FormDropdown
                            title={window.feedbackStatus[this.state.status] ? window.feedbackStatus[this.state.status].label : 'All'}
                            titleCount={this.formatStatusCount(this.state.status)}
                            items={this.getStatusDropdownItems()}
                            classes={"mr-2 roboto"}
                            buttonClasses={"roboto"}
                        />
                    </div>
                    {this.props.state.title !== "More" && <div className="d-none d-xl-flex btn btn-primary text-nowrap" onClick={this.handleExportClick.bind(this)}>
                        {__('Export to Spreadsheet')}
                    </div>}
                </div>
            </Bar>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(SearchBar);
